import { render, staticRenderFns } from "./ChartPc.vue?vue&type=template&id=38052fba&scoped=true"
import script from "./ChartPc.vue?vue&type=script&lang=js"
export * from "./ChartPc.vue?vue&type=script&lang=js"
import style0 from "./ChartPc.vue?vue&type=style&index=0&id=38052fba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38052fba",
  null
  
)

export default component.exports